import PropTypes from 'prop-types';
import styles from './Breadcrumb.module.scss'; 
import { NavLink } from 'react-router-dom';
import { ArrowRightOutlined, HomeOutlined } from '@ant-design/icons';

const Breadcrumb = ({ parentLink, parentLinkTitle, title, canSee = false }) => {
    return (
        <nav aria-label="Breadcrumb" className={styles.breadcrumbContainer}>
            {parentLink && parentLinkTitle && (
                <div className={styles.breadcrumb}>
                    <NavLink 
                        to={canSee ? parentLink : '#'} 
                        className={styles.breadcrumbLink}
                        aria-current={!canSee ? 'page' : undefined}
                    >
                        <HomeOutlined aria-hidden="true" />
                        {parentLinkTitle}
                    </NavLink>
                    <span className={styles.separator} aria-hidden="true">
                        <ArrowRightOutlined size={12} />
                    </span>
                    <span className={styles.currentPage}>
                        {title}
                    </span>
                </div>
            )}
        </nav>
    );
};

Breadcrumb.propTypes = {
    parentLink: PropTypes.string,
    parentLinkTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    canSee: PropTypes.bool,
};

export default Breadcrumb;